/**
 * <ReportConceptRow> — one subject's notions covered during the session (molecule, L0.1).
 *
 * The subject icon, its name in the subject color, and the notions joined by ", " underneath —
 * the legacy "NOTIONS ABORDÉES" row (`LiveReportComponent:1058-1088`). Composes DS atoms only.
 * No hex.
 */
import React from "react"
import { StyleSheet } from "react-native-unistyles"

import { Row } from "../../atoms/containers/Row"
import { Stack } from "../../atoms/containers/Stack"
import { ImageIcon } from "../../atoms/icons/ImageIcon"
import { Text } from "../../atoms/typography/Text"
import { type UILiveSessionReportConceptGroup } from "../../../ports/primary/ui/types"

export type ReportConceptRowProps = {
    group: UILiveSessionReportConceptGroup
    testID?: string
}

export function ReportConceptRow(props: ReportConceptRowProps) {
    const { group, testID } = props
    const { subject, concepts } = group

    return (
        <Row gap="3" align="center" testID={testID}>
            <ImageIcon uri={subject.iconUrl} size={40} />
            <Stack gap="1" style={styles.shrink}>
                <Text weight="semibold" color={subject.color}>
                    {subject.name}
                </Text>
                <Text size="text-md" color="text-primary">
                    {concepts.join(", ")}
                </Text>
            </Stack>
        </Row>
    )
}

const styles = StyleSheet.create(() => ({
    shrink: {
        flexShrink: 1,
    },
}))
